
/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
|
| Now that you configured your website, you can write additional Javascript
| code inside the following function. You might want to add more plugins and
| initialize them in this file.
|
*/

$(function() {

	$('#feedback a').click(function(e){
        e.preventDefault();
		location.replace('http://www.google.com');
	});

	$('.nav-link').click(function(){
		var url = $(this).attr("data-value");
        location.replace(url);
	});

    $('.navbar-brand').click(function(){
        var url = $(this).attr("data-value");
        location.replace(url);
    });

    $('.news-click').click(function(){
        var url = $(this).attr("data-value");
        location.replace(url);
    });




    var showed = localStorage.getItem("show-pop-up");
    if(!showed)
	{
        $("#esc-exit-popup").addClass("show");
        $("#trainning-popup").addClass("show");
        localStorage.setItem("show-pop-up", 1);
	}

	function doClose(e)
	{
		// console.log(123);
		if (!e) e = window.event;

		if (e.keyCode)
		{
			if (e.keyCode == "27")
            {
                window.close();
                $('body').hide();
                location.replace("https://www.google.com.au");
            }

		}
		else if (e.charCode)
		{
			if (e.charCode == "27")
            {
                window.close();
                $('body').hide();
                location.replace("https://www.google.com.au");
            }
		}
	}

	$(document).keydown(doClose);

	// window.location.reload();
	$('.redirect-to-page').click(function(){
		var url = $(this).attr("data-value");

		if(url === "https://google.com"){
            location.replace(url);
		}else{
            window.open(url, "_blank");
		}

	});
	
	const hobartTime = new Date().toLocaleString("en-US", { timeZone: "Australia/Hobart" });
	const currentTime = new Date(hobartTime);
		
	const startTime = new Date("2024-12-24T13:00:00"); // 1 PM 24/12/2024
	const endTime = new Date("2025-01-02T09:00:00"); // 9 AM 2/1/2025
	if (currentTime >= startTime && currentTime <= endTime) {
		document.querySelector(".popup-banner").classList.remove("popup-banner-hide");
		document.querySelector(".popup-banner").style.opacity = "1";
		document.querySelector(".header-bg").classList.add("header-bg-hide");
		document.querySelector(".contact-success").textContent = "Please be advised that SafeChoices will be closed from 12.00pm, Tuesday, 24 of December 2024 to 9.00am on Thursday, 2 January 2025 and we will not be available during this period. For support during this time, please contact: Family Violence Counselling and Support Service on 1800 608 122, 1800 Respect for 24/7 support, or call 000 in case of emergency."
	} else {
		document.querySelector(".header-bg").classList.remove("popup-banner-hide");
	}


});
